import React, {useEffect, useState, useRef} from 'react';
import { useSelector } from 'react-redux';
import Tour from 'reactour';
import { changeTourAvailability } from '../../layout/user/store/actions/action';
import { useDispatch } from 'react-redux';
import SarasDialogCustomAction from '../container/popup/SarasDialogCustomAction';
import SarasButton from '../input/buttons/button/SarasButton';
import SarasModal from '../container/popup/SarasModal';
import useSarasStore from '../hooks/localDB/useSarasStore'
import logots from '../../logo/app_typescript.svg';

//this components checks for the stepkey for a given version and will render an anouncement if tour needs to be shown
const SarasTour = (props) => {
    const {steps, tourKey } = props;
    const [version, setVersion] = useState("");
    const [showAnnouncement, setShowAnnouncement] = useState(false);
    const [isTourOpen, setIsTourOpen] = useState(false);

    const tourRef = useRef();

    const activateTour = useSelector(state => state.tourState.activateTour);

    const totalSteps = steps.length;
    const stepsWithProgress = steps.map((step, idx) => ({
    ...step,
    content: (
        <div>
        <div style={{ fontWeight: 'bold', marginBottom: 8 }}>
            Step {idx + 1} of {totalSteps}
        </div>
        {typeof step.content === 'string' ? step.content : step.content}
        </div>
    )
    }));

    const dispatchTourState = useDispatch();
    const localDb = useSarasStore();

    const checkIfVersionChanged = () => {
        if(!version){
            localDb.getAppVersion(onLocalVersionSuccess);
        }
    };

    useEffect(checkIfVersionChanged, [version]);

    const activateTourCommand = () => {
        // console.log("run tour command", steps);
        if(steps && steps.length > 0 && activateTour === 1) {
            setIsTourOpen(true);
        }
    }

    useEffect(activateTourCommand, [steps, activateTour]);

    const updateTourAvailability = () => {
        // console.log("run tour command", steps);
        if(steps && steps.length > 0) {
            onTourStateChange(1);
        }
        else {
            // console.log("run tour command no steps", steps);
            onTourStateChange(0);
        }
    }

    useEffect(updateTourAvailability, [steps]);

    useEffect(() => {
        // Cleanup: reset tour availability when component unmounts
        return () => {
            dispatchTourState(changeTourAvailability(0, -1));
        };
    }, [dispatchTourState]);

    const onLocalVersionSuccess = (key, value) =>  {
        if(value){
            setVersion(value);
            localDb.requestTourData('tour.' + tourKey + '-version-' + value, onTourStateSuccess);
        }
    }

    const onTourStateSuccess = (key, value) => {
        if(value && value === "1") setShowAnnouncement(false);
        else setShowAnnouncement(true);
    }

    const onStartTour = () => {
        setShowAnnouncement(false);
        setIsTourOpen(true);
    };

    const onCloseTour = () => {
        setIsTourOpen(false);
        setShowAnnouncement(false);
        onTourStateChange(-1, -1);
        localDb.setTourData('tour.' + tourKey + '-version-' + version, "1");
    };

    const onTourStateChange = (isTourAvailable) => {
        //default to -1, so that tour is not activated
        dispatchTourState(changeTourAvailability(isTourAvailable, -1));
    }

    return (
        <>
            {showAnnouncement && (
                <SarasModal enableModal={true} modelState={true} >
                <SarasDialogCustomAction formStyle={{ width: '420px' }}
                    title=""

                    actionChildren={
                        <>
                            <div className="uiMarginT10" style={{clear: "both"}}>
                                <div className="phAction">
                                    <div className='uiFlexDistributed'>
                                        <SarasButton className="uiSecondaryAction" onClick={onCloseTour}>Maybe Later</SarasButton>
                                        <SarasButton
                                            starIcon="tour"
                                            className="" onClick={onStartTour}>Start Tour</SarasButton>
                                    </div>
                                </div>
                                <div style={{clear: "both"}} />
                            </div>
                        </>
                    }
                    >
                    {
                        <div className="uiSarasTourAnnouncement">
                            <div className="uiSarasTourTitle">
                                Welcome to <img src={logots} height={18} alt="logo" className='uiAppMenuLogo' /> version {version}!
                            </div>
                            <div className="uiSarasTourChanges">
                                Learn about the system using <br/> 
                                <strong>"What's New!"</strong> and <strong>"Help?"</strong> Your one-stop assistance.
                                <br/>Accessible from the top right corner of the application.
                            </div>
                            <div className="uiSarasTourQuestion">
                                Would you like to have a quick tour <br/> to explore the latest features on this page?
                            </div>
                        </div>
                    }
                </SarasDialogCustomAction>
                </SarasModal>
            )}
            <Tour
                steps={stepsWithProgress}
                isOpen={isTourOpen}
                onRequestClose={onCloseTour}
                disableInteraction={true}
                nextButton={<SarasButton className="uiPrimaryAction">Next</SarasButton>}
                prevButton={<SarasButton className="uiSecondaryAction">Back</SarasButton>}
                accentColor="#3F92FF" // your brand color
                disableDotsNavigation={true} // hides the dots
                ref={tourRef}
            />
        </>
    )
}

export default SarasTour;
